import { CollectDataStepStatus } from 'src/constants/collect-data/enums'
import { TERMINAL_STEP_STATUSES } from 'src/constants/partnerDriver/constants'
import type { PartnerDriverStep } from 'src/interfaces/partnerDriver'

const isActiveStep = (step: PartnerDriverStep): boolean => {
  return !TERMINAL_STEP_STATUSES.includes(step.status)
}

const isCompletedStep = (step: PartnerDriverStep): boolean => {
  return step.status === CollectDataStepStatus.Completed
}

/**
 * Retool `setSteps` parity: for steps sharing `type` + `label`, show the one that is not finished
 * (completed, completed_not_active or archived — a recollection creates a new step beside the
 * completed one, and completed_not_active is a future-dated renewal, not the live step); if every
 * duplicate is finished, prefer a completed one, else show the first.
 */
export const dedupeSteps = (steps: PartnerDriverStep[]): PartnerDriverStep[] => {
  const groups = new Map<string, PartnerDriverStep[]>()
  const keys: string[] = []

  steps.forEach((step) => {
    const key = `${step.type}::${(step.label ?? '').trim()}`
    const group = groups.get(key)

    if (group) {
      group.push(step)

      return
    }

    groups.set(key, [step])
    keys.push(key)
  })

  return keys.reduce<PartnerDriverStep[]>((accumulator, key) => {
    const group = groups.get(key) ?? []
    const chosen = group.find(isActiveStep) ?? group.find(isCompletedStep) ?? group[0]

    if (chosen) {
      accumulator.push(chosen)
    }

    return accumulator
  }, [])
}
